import React, { Component } from 'react'
import Item from '../Item'
import { Flex } from 'hljd'
import { observer, inject } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { taskPageData } = this.props.store

    return (
      <Flex wrap style={{ margin: '0 -10px' }}>
        {(taskPageData.list || []).map(item => {
          return <Item key={item.entity} {...item} store={this.props.store} />
        })}
      </Flex>
    )
  }
}
